import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import {
  renderArrowPrev,
  renderArrowNext,
  renderIndicator,
} from 'components/CustomCarousel/customize';
import { CarouselContainer } from 'components/CustomCarousel/styles';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

const settings = {
  swipeable: true,
  emulateTouch: true,
  showStatus: false,
  infiniteLoop: false,
  showThumbs: false,
  autoPlay: false,
  renderArrowNext,
  renderArrowPrev,
  renderIndicator,
};
const CustomCarousel = (props: any) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  return (
    <CarouselContainer reverse={reverse}>
      <Carousel
        {...settings}
        showIndicators={props.showIndicators}
        className="direction"
      >
        {props.children}
      </Carousel>
    </CarouselContainer>
  );
};

export default CustomCarousel;
